'use client';

import * as React from 'react';
import type { LucideIcon } from 'lucide-react';

import { cn } from '@/lib/utils';
import { EntitySubtitle } from './EntityTitle';
import { MicroText } from './MicroText';

export type StepCardProps = {
  icon: LucideIcon;
  step: string | number;
  title: string;
  description: string;
  className?: string;
};

export function StepCard({ icon: Icon, step, title, description, className }: StepCardProps) {
  return (
    <div
      className={cn('border border-border bg-card p-3 space-y-2', className)}
      style={{ boxShadow: 'var(--shadow-warm-sm)' }}
    >
      <div className="flex items-center gap-2">
        <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-primary/10">
          <Icon className="h-3.5 w-3.5 text-primary" aria-hidden />
        </div>
        <MicroText className="font-bold uppercase tracking-widest text-foreground/40">Step {step}</MicroText>
      </div>
      <EntitySubtitle as="p">{title}</EntitySubtitle>
      <p className="text-body text-muted-foreground leading-relaxed">{description}</p>
    </div>
  );
}
